module.exports = __webpack_public_path__ + "img/editor.62f9e05b.svg";